import React from "react";
import SpinnerIcon from "./SpinnerIcon";

const Spinner = (props) => {
  return (
    <div className="Spinner">
      <SpinnerIcon />
    </div>
  );
};
/**
 * .Spinner {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
 */
export default Spinner;
